(() => {
  const labels = {
    save: "\u0026amp; Save __amount__",
    onePoints: "Earn __points__ points",
    subPoints: "Earn __first__ points then __points__ every __interval__"
  };
  window.createSubscriptionModifier = data => {
    const template = document.getElementById('subscription-modifier-template');
    if (!template) return document.createDocumentFragment();
    const form = template.content.cloneNode(true).firstElementChild;
    form.querySelector('[name="id"]').value = data.line_item_key;
    form.querySelector('[name="quantity"]').value = data.quantity;
    const selector = form.querySelector('sa-subscription-selector');
    selector.querySelector('[data-subscription-config]').textContent = JSON.stringify({
      context: 'cart', productId: data.line_item_key, variantId: data.variant_id,
      initialPlan: String(data.selected_plan_id || ''), currency: data.currency || 'GBP',
      pointsPerPound: 4,
      bonusPoints: 50, labels,
      variants: [{id: data.variant_id, price: data.original_price, requiresPlan: data.requires_selling_plan,
        plans: data.selling_plans.map(plan => ({id: String(plan.id), interval: plan.interval, price: plan.discounted_price, adjustmentType: plan.type, adjustmentValue: plan.value}))}]
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.pending === 'true') return;
      selector.sync();
      const error = form.querySelector('[role="alert"]');
      if (!selector.valid()) { error.textContent = form.dataset.updateError; error.hidden = false; return; }
      form.dataset.pending = 'true'; error.hidden = true;
      const button = document.getElementById('subscription-update-button');
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: data.line_item_key, quantity: Number(data.quantity), selling_plan: selector.input.value || null})
        });
        if (!response.ok) throw new Error('Cart update failed');
        await response.json();
        const popover = form.closest('x-drawer-popover');
        if (typeof popover?.hide === 'function') popover.hide();
        else popover?.removeAttribute('open');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      } catch {
        error.textContent = form.dataset.updateError;
        error.hidden = false;
      } finally {
        form.dataset.pending = 'false';
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }
    });
    return form;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.subscription-launcher[data-debug]');
    if (!button) return;
    const container = document.getElementById('subscription-selector-container');
    if (!container) return;
    try { container.replaceChildren(window.createSubscriptionModifier(JSON.parse(button.dataset.debug))); }
    catch { container.textContent = "We couldn\u0026#39;t confirm the update. Refresh your cart to check this item before trying again."; }
  });
})();
